import { Button, Text } from '@consumidor-positivo/aurora';
import './styles.scss';
type AnnualFeeProps = {
  annualFilter: boolean;
  changeAnnualFilter: () => void;
};

export const AnnualFee = ({ annualFilter, changeAnnualFilter }: AnnualFeeProps) => {
  return (
    <div className="mm-annual-fee">
      <Text as="span" variant="body-medium" color="secondary">
        Filtros:
      </Text>
      <div className="mm-annual-fee__value">
        <Text as="span" variant="body-small" weight="semibold">
          {annualFilter ? 'Com anuidade' : 'Sem anuidade'}
        </Text>
        <Button type="link" onClick={changeAnnualFilter}>
          Trocar
        </Button>
      </div>
    </div>
  );
};
